import type { SVGProps } from "react";
export interface LeafIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function LeafIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: LeafIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M12.498 8.994a1.125 1.125 0 0 1 1.004 2.012c-1.748.875-4.116 2.692-8.066 8.618a11 11 0 0 1-.252.356 1.125 1.125 0 0 1-1.811-1.336 7 7 0 0 0 .19-.268c4.05-6.073 6.683-8.257 8.935-9.382"
      />
      <path
        fill={color}
        d="M19.88 1.894c1.118-.15 2.27.68 2.244 1.961-.053 2.665-.308 5.914-1.113 8.896-.799 2.957-2.186 5.833-4.64 7.52-3.206 2.203-7.3 2.321-11.324.968-1.281-.431-2.351-1.454-2.712-2.844-.841-3.247-.723-8.08 2.053-11.226 2.058-2.333 4.876-3.327 7.605-3.904 1.367-.289 2.762-.483 4.058-.672 1.315-.192 2.524-.378 3.606-.655zm-.016 2.304c-1.115.263-2.308.45-3.488.621-1.324.194-2.636.376-3.917.646-2.406.509-4.525 1.298-6.08 2.868l-.304.324c-2.078 2.357-2.308 6.291-1.561 9.173.15.578.612 1.061 1.25 1.276 3.585 1.205 6.884.992 9.333-.69 1.804-1.24 2.998-3.496 3.741-6.25.7-2.595.958-5.473 1.026-7.968"
      />
    </svg>
  );
}
